import { useApp } from '@libs/hooks';
import { ConditionalRender } from '@libs/utils';
import clsx from 'clsx';
import React from 'react';
import Dash from '../../../common/Dash';
import { getInlineStyles } from '../../../utils/styles';
import styles from './popupComponent.module.css';

type TPopupComponentProps = {
    header?: string | React.ReactNode;
    internalContent?: React.ReactNode;
    externalContent?: Array<React.ReactNode>;
    withoutSeparator?: boolean;
    textAlign?: 'start' | 'end' | 'center' | 'justify' | 'left' | 'right';
    fixedHeight?: boolean;
};

const PopupComponent = ({ header, withoutSeparator, internalContent, externalContent, textAlign, fixedHeight = false }: TPopupComponentProps) => {
    const { setPopup } = useApp();
    return (
        <>
            <ConditionalRender condition={!!header || !!internalContent}>
                <div className={clsx(styles.popupBoxContentWrapper, fixedHeight && styles.fixedHeight)}>
                    <Dash onTouchEnd={() => setPopup(null)} />
                    <div className={styles.popupBoxContent}>
                        {header && (
                            <div className={styles.popupBoxHeader} style={getInlineStyles({ variables: { textAlign: textAlign ?? 'center' } })}>
                                {header}
                            </div>
                        )}
                        {internalContent && (
                            <div className={clsx(styles.popupInternalContent, !withoutSeparator && styles.withSeparator)}>{internalContent}</div>
                        )}
                    </div>
                </div>
            </ConditionalRender>
            <ConditionalRender condition={Array.isArray(externalContent)}>
                {externalContent?.map((button, index) => (
                    <div className={styles.popupExternalContent} key={index}>
                        {button}
                    </div>
                ))}
            </ConditionalRender>
        </>
    );
};

export { PopupComponent };
